export default "__VITE_ASSET__BTNo2xVu__"